module.exports = __webpack_public_path__ + "img/check-circle-blue.756dff7d.svg";